import loanbox_Illustration from "../../webroot/images/login_bg.svg";
import logo from "../../webroot/images/logo-login.svg";
import { useTranslation } from "react-i18next";
import SsoLoginComponent from "./SsoLogin";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import secureStorage from "./../../config/encrypt";
import { useEffect, useState } from "react";
import { UserActions } from "../../store/action";
import FullPageLoader from "../common/FullPageLoader";
import { REQUEST_FROM_HEADER_KEY, REQUEST_FROM_HEADER_VALUE } from "../../config/constant";

function Login() {
  const { t } = useTranslation("common");
  const history = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loggedInUser = secureStorage.getItem("authUserInfo");
    if (loggedInUser && loggedInUser.user_data) {
      history("/dashboard");
    }
  }, [history]);

  useEffect(() => {
    const userDataParam = searchParams.get("userdata");
    if (userDataParam) {
      try {
        const parsedData = JSON.parse(decodeURIComponent(userDataParam));
        if (
          (!parsedData.domain && parsedData.email) ||
          parsedData.domain !== "Invalid"
        ) {
          setLoading(true);
          dispatch(UserActions.creatLoginOtp({ email: parsedData.email, [REQUEST_FROM_HEADER_KEY]: REQUEST_FROM_HEADER_VALUE })).then(
            (res) => {
              setLoading(false);
              if (res && res.status === 200) {
                history("/dashboard");
              } else {
                history("/login");
              }
            },
          );
        } else {
          toast.error("Domain is Invalid");
          const urlParams = new URLSearchParams(location.search);
          if (urlParams.has("userdata")) {
            urlParams.delete("userdata");
            const newUrl = `${location.pathname}`;
            history(newUrl);
          }
        }
      } catch (error) {
        console.error("Failed to parse userdata:", error);
      }
    }
  }, [searchParams, dispatch, history, location.pathname, location.search]);

  return (
    <>
      <FullPageLoader show={loading} />
      <div className="container-fluid">
        <div className="row">
          <div className="login-outer">
            <div className="login-left-panel">
              <div className="login-bg">
                <div className="logo-img">
                  {<img src={logo} className="" alt="logo" />}
                </div>

                <div className="login-txt">
                  <span></span>
                </div>
                {
                  <img
                    src={loanbox_Illustration}
                    className="login-bg-img"
                    alt="logo-bg"
                  />
                }
              </div>
            </div>
            <div className="login-right-panel">
              <div className="login-heading">
                <h2>{t("COMMON.WELCOME_INECNTIVEBOX")}</h2>
              </div>
              <SsoLoginComponent />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
